import React from 'react';
import { makeStyles } from '@material-ui/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import List from '@material-ui/core/List';
import ItemFood from './ItemFood';
import ItemDelivery from './ItemDelivery';



const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    //backgroundColor: 'blue',
  },

  content: {
    padding: theme.spacing(2,0,0),
    [theme.breakpoints.up('md')]: {
      //backgroundColor: 'blue',
      paddingLeft: '10%',
      paddingRight: '10%'
    },

    //backgroundColor: 'blue',
  },


  paper: {
    padding: theme.spacing(1,1,2,1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    
  },

  imageCategory:{
    width: "95%",
    borderRadius: 16,
    
    [theme.breakpoints.up('md')]: {
      //backgroundColor: 'blue',
      width: "50%",
      borderRadius: 16,
    },
    

  },

  divImage:{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(2,0,0,0),
  },

  nameCategory:{
    //fontFamily: "'Baloo 2', cursive",
    width: '100%',
    //textTransform: 'uppercase',
    textAlign:'left', 
    color: theme.palette.text.muted,
  }

}));

export default function Category(props) {
     const classes = useStyles();
     const category = props.category
     category.items = category.items.filter(element=> element.hide==false)
     const {currency,showCurrency,isTakingOrder,strings} = props
     const {orderList, setOrderList, onOrderListChange,onOrderAddItemAdditions} = props; 
     
     return(
          <Grid item xs={12} sm={7} >

            {category.image?
             <div  className={classes.divImage}>
              <img className ={classes.imageCategory} src={category.image} alt={"image"} />
             </div>
             :""
            }

            <div className={classes.content}>  
            <Paper  elevation={0} className={classes.paper}>
            <Typography variant="h5" className={classes.nameCategory} >
             {category.name} 
            </Typography>
            </Paper>
            
            <List>
               {category.items.map((item)=>(   
                  item.type== "DELIVERY_SERVICE"?
                  <ItemDelivery 
                    key={item.uid} 
                    item={item}
                    showPrice={category.showPrice}
                    showImage = {category.showPictures}
                    onOrderListChange = {onOrderListChange}
                    orderList={orderList}
                    setOrderList={setOrderList}
                    currency = {currency}
                    showCurrency = {showCurrency}
                    isTakingOrder={isTakingOrder}
                    strings={strings}
                  />
                  : 
                  <ItemFood 
                  key={item.uid} 
                  item={item}
                  showPrice={category.showPrice}
                  showImage = {category.showPictures}
                  onOrderListChange = {onOrderListChange}
                  orderList={orderList}
                  setOrderList={setOrderList}
                  currency = {currency}
                  showCurrency = {showCurrency}
                  isTakingOrder={isTakingOrder}
                  onOrderAddItemAdditions={onOrderAddItemAdditions}
                  />
               ))}
            </List>                             

            </div>
          </Grid>
    );
}